import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LoginComponent } from '../login/login.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public activeOption = 'arrow_back';
  public reviews = [];
  public news = [];
  public showPosicion = 1;

  constructor(private dialog: MatDialog, private router: Router) {}

  ngOnInit(): void {
    this.getReviews();
    this.getNews();
  }

  goTo(url) {
    window.open(url, '_blank');
  }
  openMarketplace() {
    this.router.navigate([`/market`]);
  }

  openConferenciaCeremonia() {
    this.router.navigate([`/confe-ceremonia`]);
  }

  openFeriasNegocios() {
    this.router.navigate([`/feria-negocios`]);
  }
  openFeriasEscolares() {
    this.router.navigate([`/feria-escolar`]);
  }

  openLoginModal(action): any {
    localStorage.setItem('loginFromDemo', 'true');

    const dialogRef = this.dialog.open(LoginComponent, {
      width: '380px',
      height: '550px',
      autoFocus: false,
      restoreFocus: true,
      hasBackdrop: true,
      data: { action: action },
    });
  }
  goToStartDemo() {
    this.router.navigate(['auth/start-demo']);
  }
  goToContact() {
    this.router.navigate(['/contact']);
  }

  getOptionSeleted(posicion, direccion) {
    if (direccion == 'back') {
      if (posicion > 1) {
        posicion = posicion - 1;
        this.showPosicion = posicion;
      }

      this.activeOption = 'arrow_back';
    }
    if (direccion == 'next') {
      if (posicion < 6) {
        this.showPosicion = posicion + 1;
      }
      this.activeOption = 'arrow_forward';
    }
    if (posicion == 6) {
      this.showPosicion = 1;
    }
  }

  convertToHtml(str, id_elemento_html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(str, 'text/html');
    var allText = doc.body.outerHTML;
    document.getElementById(id_elemento_html).innerHTML = allText;
  }

  getReviews() {
    this.reviews = [
      {
        posicion: 1,
        id_elemento_html: 'descripcion1',
        logo_empresa:
          'https://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/08/Logos-Kaleidolab-ocensa.jpg',
        nombre_usuario: 'Andrés Angarita Saenz',
        cargo_usuario: 'Jefe de Innovación',
        comentario:
          'Resalto nuestro proyecto en tres frentes:<br /> 1. La lectura real frente a la oportunidad que teníamos y la propuesta realizada. <br /> 2. El valor generado a partir de la tecnología, lo cual nos permitió generar mejores resultados en términos de seguridad en HSE.',
      },
      {
        posicion: 2,
        id_elemento_html: 'descripcion2',
        logo_empresa:
          'https://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/08/Logos-Kaleidolab-Q-1.jpg',
        nombre_usuario: 'Mónica Ruiz Giraldo',
        cargo_usuario: 'Asociada de Desarrollo Humano',
        comentario:
          'A través de la herramienta de Realidad Virtual he encontrado una valiosa metodología para fortalecer el aprendizaje de una manera práctica, en donde un operario de manufactura puede simular la manipulación de la máquina y el proceso productivo...',
      },
      {
        posicion: 3,
        id_elemento_html: 'descripcion3',
        logo_empresa:
          'http://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/09/logo-de-centro-de-innovacion.png',
        nombre_usuario: 'Guillermo Solano',
        cargo_usuario: 'Director Centro de Innovación, Bogotá - Colombia',
        comentario:
          '"Uno de los grandes desafíos en procesos de innovación es la dificultad para tener prototipos de alta calidad para validar las ideas. En el caso del programa Catalizadores de la innovación, donde teníamos a más de 30 instituciones públicas diseñando aplicativos digitales para solucionar problemas de la administración pública ...',
      },
      {
        posicion: 4,
        id_elemento_html: 'descripcion4',
        logo_empresa:
          'https://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/08/Logos-Kaleidolab-hoypstools.jpg',
        nombre_usuario: 'Jairo Tangarife',
        cargo_usuario: 'Gerente CEO',
        comentario:
          'Hemos encontrado en KALEIDO LAB un Aliado fundamental en la colocación de esas nuevas tendencias tecnológicas. Gracias a sus desarrollos que han llevado un alto grado de ingeniería, nuestros visitantes virtuales cada vez son más, eso nos ha llevado a un crecimiento en venta en el último año de aproximadamente un 46 %...',
      },
      {
        posicion: 5,
        id_elemento_html: 'descripcion5',
        logo_empresa:
          'https://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/08/Logos-Kaleidolab-gransori.jpg',
        nombre_usuario: 'Rafael Osorio',
        cargo_usuario: 'Gerente General',
        comentario:
          'En nuestro centro de innovación Kom-in, hemos contado con el soporte de Kaleido Lab. Ha sido muy interesante para mostrar nuestros espacios y la experiencia que ofrecemos. Vemos mucho potencial para el desarrollo de futuros proyectos con Kaleido Lab.',
      },
      {
        posicion: 6,
        id_elemento_html: 'descripcion6',
        logo_empresa:
          'https://www.kaleidolab.scenariovr.co/wp-content/uploads/2021/08/Logos-Kaleidolab-quid.png',
        nombre_usuario: 'Santiago García',
        cargo_usuario: 'Co-fundador',
        comentario:
          'Trabajar con Kaleido es trabajar con alguien que se interesa en tus necesidades. Buscan empatizar con tus proyectos o tu modelo de negocio y de esta forma generar el mayor valor para tus necesidades.',
      },
    ];
    if (this.showPosicion > 0) {
      setTimeout(() => {
        this.reviews.forEach((review) => {
          this.convertToHtml(review.comentario, review.id_elemento_html);
        });
      }, 100);
    }
  }
  getNews() {
    this.news = [
      {
        link_imagen_noticia:
          'https://diariobitcoin.b-cdn.net/wp-content/uploads/2022/06/metaverso-unsplash.jpg',
        link_noticia:
          'https://www.diariobitcoin.com/metaverso/el-metaverso-podria-valer-nada-mas-y-nada-menos-que-usd-5-billones-para-2030/',
        titulo_noticia:
          'El metaverso podría valer nada más y nada menos que USD $5 billones para 2030',
      },
      {
        link_imagen_noticia:
          'https://s03.s3c.es/imag/_v0/1200x655/d/b/a/metaverso.jpg',
        link_noticia:
          'https://www.eleconomista.es/tecnologia/noticias/11815807/06/22/Francia-sera-el-primer-pais-en-tener-una-academia-especifica-para-el-met',
        titulo_noticia:
          'Francia será el primer país en tener una academia específica para el metaverso',
      },
      {
        link_imagen_noticia:
          'https://gestion.pe/resizer/eF9V50Ngzxp56ISlHRYJbKyEakk=/580x330/smart/filters:format(jpeg):quality(75)/cloudfront-us-east-1.images.arcpublishing.com/elcomercio/PXA2AULBRFCVHBJHCKX63LMSC4.jpg',
        link_noticia:
          'https://www.larepublica.co/analisis/stefan-krautwald-3166366/metaverso-oportunidad-para-colombia-3260090',
        titulo_noticia: 'Metaverso, ¿oportunidad para Colombia?',
      },
      {
        link_imagen_noticia: 'https://cdn.forbes.co/2022/04/Saju.jpg',
        link_noticia:
          'https://forbes.co/2022/04/13/editors-picks/asi-es-el-metaverso-made-in-colombia/',
        titulo_noticia: 'Así es el metaverso ‘made in Colombia’',
      },
    ];
  }

  truncateText(texto) {
    return texto.substr(0, 100) + '...';
  }

  carrusel() {}
}
